import { GET } from 'shared/utils/ajax';

/**
 * 미디어 말하기 가져오기
 * @param {string} upc
 */
export const getSpeak$ = upc => GET(`/rest/media/speak/${upc}`);
